import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76cc93d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body pb-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-3",
  "aria-busy": "true",
  "aria-live": "polite"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center gap-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-pulse skeleton-avatar" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-pulse skeleton-title w-50" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column gap-2 ps-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-pulse skeleton-line skeleton-lg" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-pulse skeleton-line skeleton-md" }),
  /*#__PURE__*/_createElementVNode("div", { class: "skeleton-pulse skeleton-line skeleton-sm w-75" })
], -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex flex-column gap-3"
}
const _hoisted_7 = { class: "d-flex align-items-center gap-3" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { class: "p-3 d-flex flex-column gap-2" }
const _hoisted_10 = { class: "d-flex flex-wrap align-items-baseline gap-2" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = {
  key: 0,
  class: "small"
}
const _hoisted_13 = { class: "d-block small" }
const _hoisted_14 = { class: "d-block small" }
const _hoisted_15 = {
  key: 0,
  class: "d-block small"
}
const _hoisted_16 = {
  key: 2,
  class: "text-muted d-flex align-items-center justify-content-center",
  style: {"height":"150px"}
}
const _hoisted_17 = { class: "mb-0 fs-4 fw-semibold text-center" }

import { computed } from 'vue';
import type { INextEvent } from '@/modern/types/dashboard';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  props: {
    nextEvent: null,
    currentLanguage: null,
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { nextEvent: INextEvent | null, currentLanguage: string, loading: boolean }

const { t } = useI18n();



const hasNextEvent = computed(() => Boolean(props.nextEvent?.name?.trim()));
const hasDescription = computed(() => Boolean(props.nextEvent?.description?.trim()));
const hasLocation = computed(() => Boolean(props.nextEvent?.location?.trim()));
const hasLink = computed(() => Boolean(props.nextEvent?.link?.trim()));

const formatDate = (dateString: string | null | undefined) => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  return date.toLocaleDateString(props.currentLanguage, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const formatHour = (dateString: string | null | undefined) => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);
  return date.toLocaleTimeString(props.currentLanguage, {
    hour: '2-digit',
    minute: '2-digit',
  });
};

const iconOptions = new Map([
  ["youtube", "bi bi-youtube"],
  ["discord", "bi bi-discord"],
  ["online_other", "bi bi-globe"],
  ["in_person", "bi bi-geo-alt-fill"],
]);

const iconName = computed(() => {
  const eventFormat = props.nextEvent?.format;

  if (eventFormat && iconOptions.has(eventFormat)) {
    return iconOptions.get(eventFormat);
  }

  return 'bi bi-calendar-event';
});

const translate = (key: string) => t(`${props.currentLanguage}.page_dashboard.${key}`);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(hasLink) ? 'a' : 'div'), {
    href: _unref(hasLink) ? props.nextEvent?.link : undefined,
    target: _unref(hasLink) ? '_blank' : undefined,
    rel: _unref(hasLink) ? 'noopener noreferrer' : undefined,
    class: _normalizeClass(["card mt-4 mt-md-0", { 'card-link': _unref(hasLink) }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (props.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
          : (_unref(hasNextEvent))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass([_unref(iconName), "next-event-icon"])
                  }, null, 2),
                  _createElementVNode("h3", _hoisted_8, _toDisplayString(translate('next_event_title')), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h4", _hoisted_11, _toDisplayString(props.nextEvent?.name), 1),
                    (_unref(hasDescription))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, "- " + _toDisplayString(props.nextEvent?.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(translate('event_date_label')) + ": " + _toDisplayString(formatDate(props.nextEvent?.date)), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(translate('event_time_label')) + ": " + _toDisplayString(formatHour(props.nextEvent?.date)), 1),
                  (_unref(hasLocation))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(translate('event_location_label')) + ": " + _toDisplayString(props.nextEvent?.location), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(translate('no_upcoming_events')), 1)
              ]))
      ])
    ]),
    _: 1
  }, 8, ["href", "target", "rel", "class"]))
}
}

})